import { ActionIcon, Stack, Text } from '@mantine/core';
import { IconArrowNarrowLeft } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { useFaqsImportMode } from '@/components/Faqs/hooks';

interface FaqsImportHeaderProps {
  onBack?: () => void;
  showDescription?: boolean;
}

export const FaqsImportHeader = ({ onBack, showDescription }: FaqsImportHeaderProps) => {
  const { t } = useTranslation();
  const mode = useFaqsImportMode();
  return (
    <div className="relative">
      {onBack && (
        <ActionIcon
          className="absolute left-0 top-0"
          color={'gray'}
          onClick={() => {
            onBack();
          }}
        >
          <IconArrowNarrowLeft />
        </ActionIcon>
      )}
      <Stack className={`text-center ${mode === 'modal' ? 'my-5' : 'my-[5%]'}`}>
        <Text fz={24} c="gray.8">
          {t('faqs.import.title')}
        </Text>
        {showDescription !== false && (
          <Text fz={16} fw={300} c="gray.5">
            {t('faqs.import.description')}
          </Text>
        )}
      </Stack>
    </div>
  );
};
